module.exports = __webpack_public_path__ + "img/E.T. Races.0a2d44f7.jpg";